namespace $ {
	export class $exso_format_class extends $mol_object {
		@$mol_mem_key
		day(date: Date | $mol_time_moment) {
			return this._day_formatter()(date instanceof $mol_time_moment ? date.native : date)
		}
		@$mol_mem_key
		date(date: Date | $mol_time_moment) {
			return this._date_formatter()(date instanceof $mol_time_moment ? date.native : date)
		}
		@$mol_mem_key
		month(date: Date | $mol_time_moment) {
			return this._month_formatter()(date instanceof $mol_time_moment ? date.native : date)
		}
		@$mol_mem_key
		minutes(minutes: number) {
			if (minutes === 0) return '0'
			return this._duration_formatter()({
				hours: Math.floor(minutes / 60),
				minutes: minutes % 60,
			})
		}
		@$mol_mem_key
		float(number: number) {
			return this._float_formatter()(number || 0)
		}
		@$mol_mem_key
		float2([number, count = -1]: [number, number]) {
			number ||= 0
			if (count !== -1) number = Math.round(number * 10 ** count) / 10 ** count
			return this._float_formatter()(number || 0)
		}
		@$mol_mem_key
		int(number: number) {
			return this._int_formatter()(Math.round(number || 0))
		}
		@$mol_mem_key
		percent(number: number) {
			return this._percent_formatter()(number || 0)
		}

		get locale() {
			return this.$.$mol_locale.lang()
		}
		@$mol_mem
		_date_formatter() {
			const intl = new Intl.DateTimeFormat(this.locale, {
				day: '2-digit',
				month: 'long',
				year: 'numeric',
			})
			return (v: Date) => intl.format(v).replace(/\.$/, '')
		}
		@$mol_mem
		_float_formatter() {
			const intl = new Intl.NumberFormat(this.locale, {})
			return intl.format.bind(intl)
		}
		@$mol_mem
		_int_formatter() {
			const intl = new Intl.NumberFormat(this.locale, {})
			return intl.format.bind(intl)
		}
		@$mol_mem
		_percent_formatter() {
			const intl = new Intl.NumberFormat(this.locale, {
				style: 'percent',
				minimumFractionDigits: 2,
			})
			return intl.format.bind(intl)
		}

		@$mol_mem
		_month_formatter() {
			const intl = new Intl.DateTimeFormat(this.locale, { month: 'long' })
			return intl.format.bind(intl)
		}
		@$mol_mem
		_day_formatter() {
			const intl = new Intl.DateTimeFormat(this.locale, {
				day: 'numeric',
				month: 'long',
			})
			return (v: Date) => intl.format(v).replace(/\.$/, '')
		}
		@$mol_mem
		_duration_formatter() {
			const intl = new Intl.DurationFormat(this.locale, { style: 'narrow' })
			return intl.format.bind(intl)
		}
	}
	export const $exso_format = new $exso_format_class()
}
